import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';


export class ProjectFinancialDataView extends Component {

	render() {
		const { totalBudget, deuContribution, nationalCoFinancing, otherCoFinancing, paidAmount, lastDateOfPayment } = this.props;
		return (
			<Card>
				<CardHeader title="Project : Financial Data" className='romis-card-header' />
				<CardContent>
					<TextField
						label="Total Budget :"
						value={totalBudget}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>,
							readOnly: true
						}}
					
					/>

					<TextField
						label="DEAU Contribution :"
						value={deuContribution}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>,
							readOnly: true
						}}
					/>
					<TextField
						label="National Co-Financing :"
						value={nationalCoFinancing}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>,
							readOnly: true
						}}

					/>
					<TextField
						label="Other Co-Financing :"
						value={otherCoFinancing}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>,
							readOnly: true
						}}
					/>
					<TextField
						label="Paid Amount :"
						value={paidAmount}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
                            startAdornment: <InputAdornment position="start">€</InputAdornment>,
							readOnly: true
						}}

					/>
					<TextField
						label="Last Date Of Payment :"
						value={lastDateOfPayment}
						fullWidth
						margin="normal"
						InputLabelProps={{
							shrink: true,
						}}
						inputprops={{
							readOnly: true,
						}}
					

					/>
				
				</CardContent>

			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/ProjectFinancialDataView.js